import { render, staticRenderFns } from "./detailExample.vue?vue&type=template&id=28cb74bd&scoped=true&"
import script from "./detailExample.vue?vue&type=script&lang=js&"
export * from "./detailExample.vue?vue&type=script&lang=js&"
import style0 from "./detailExample.vue?vue&type=style&index=0&id=28cb74bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cb74bd",
  null
  
)

export default component.exports